/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Input, Table, Button, Tag, Tooltip, message, Popconfirm, Modal, Form } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import UilLock from '@iconscout/react-unicons/icons/uil-lock-alt';
import UilUnLock from '@iconscout/react-unicons/icons/uil-unlock-alt';
import { TableWrapper } from '../../../container/styled';
import { BtnWithIcon, Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { themeColor } from '../../../config/theme/themeVariables';

function DocumentCategories() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editId, setEditId] = useState(null);

  const fetchTableData = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/document-categories/query', {
        page: currentPage,
        pageSize,
        search,
      });
      const { data, total, status, message: msg } = response.data;
      if (status) {
        setTableData(data);
        setTotalRows(total);
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error(`Error fetching table data: ${error.message}`);
    } finally {
      setBusy(false);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchTableData();
    if (reload) setReload(false);
  }, [currentPage, pageSize, search, reload]);

  const handleEditRowClick = (event) => {
    const { currentTarget } = event;
    const dataID = Number(currentTarget.getAttribute('data-index') || 0);
    const record = tableData.find(item => item.id === dataID);
    if (record) {
      setEditId(dataID);
      form.setFieldsValue({ title: record.title });
      setIsModalVisible(true);
    }
  };

  const handleStatusChange = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0);
      const record = tableData.find(item => item.id === dataID);

      if (record) {
        setBusy(true);
        const response = await DataService.post('/document-categories/change-status', {
          id: dataID
        });

        const { status, message: msg } = response.data;
        if (status) {
          setReload(true);
          message.success(msg);
        } else {
          message.error(msg);
        }
      }
    } catch (error) {
      message.error(`Error updating status: ${error.message}`);
    } finally {
      setBusy(false);
    }
  };

  const handleFormSubmit = async (values) => {
    try {
      setBusy(true);
      const endpoint = editId ? '/document-categories/update' : '/document-categories/create';
      const payload = editId ? { ...values, id: editId } : values;

      const response = await DataService.post(endpoint, payload);
      const { status, message: msg } = response.data;

      if (status) {
        message.success(msg);
        setIsModalVisible(false);
        form.resetFields();
        setEditId(null);
        setReload(true);
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error(`Error saving category: ${error.message}`);
    } finally {
      setBusy(false);
    }
  };

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (status) => {
    //     const color = status ? themeColor['success-color'] : themeColor['danger-color'];
    //     const text = status ? 'Active' : 'Inactive';
    //     return <Tag color={color}>{text}</Tag>;
    //   },
    // },
    {
      title: 'IsActive',
      dataIndex: 'status',
      key: 'status',
      field: 'status',
      onCell: () => ({ className: 'w-10' }),
      export: true,
      render: (is_active) => {
        let color = themeColor['danger-color']
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Actions',
      key: 'actions', 
      width: 10,
      export: false,
      render: (_, record) => (
        <div className='flex flex-row justify-between select-none'>
          <Tooltip title='Edit Category' className='select-none'>
            <BtnWithIcon
              onClick={handleEditRowClick}
              data-index={record.id}
            >
              <UilPen
                className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                size={20}
              />
            </BtnWithIcon>
          </Tooltip>
          <Tooltip title={`${record.status ? 'Block' : 'Unblock'} category`} className='select-none'>
            <Popconfirm
              title={`Are you sure to ${record.status ? 'block' : 'unblock'} this category?`}
              onConfirm={handleStatusChange}
              okButtonProps={{
                'data-index': record.id
              }}
              okText="Yes"
              cancelText="No"
            >
              <BtnWithIcon className='ninjadash-delete'>
                {record.status ?
                  <UilLock
                    className='ninjadash-delete hover:scale-110 hover:text-red-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                  :
                  <UilUnLock
                    className='ninjadash-delete hover:scale-110 hover:text-green-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                }
              </BtnWithIcon>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Document Categories" routes={[]} />
      <Main>
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Input
              className="hover:drop-shadow-xl hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
              size='small'
              autoFocus
              placeholder="Search Categories"
              prefix={<UilSearch size={15} />}
              defaultValue={search}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              type="primary"
              onClick={() => {
                setEditId(null);
                form.resetFields();
                setIsModalVisible(true);
              }}
            >
              Add New Category
            </Button>
          </div>

          <div className="ninjadasj-datatable">
            <TableWrapper>
              <Table
                rowKey="id"
                loading={busy}
                bordered
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={tableData}
                columns={columns}
                scroll={{ x: 'max-content' }}
              />
            </TableWrapper>
          </div>
        </div>

        <Modal
          title={editId ? "Edit Category" : "Add New Category"}
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            setEditId(null);
            form.resetFields();
          }}
          footer={null}
        >
          <Form
            form={form}
            onFinish={handleFormSubmit}
            layout="vertical"
          >
            <Form.Item
              name="title"
              label="Category Title"
              rules={[{ required: true, message: 'Please enter category title' }]}
            >
              <Input placeholder="Enter category title" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={busy}>
                {editId ? 'Update' : 'Create'}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </Main>
    </>
  );
}

export default DocumentCategories; 